import { render, staticRenderFns } from "./PointSetting.vue?vue&type=template&id=f85c764e&scoped=true"
import script from "./PointSetting.vue?vue&type=script&lang=js"
export * from "./PointSetting.vue?vue&type=script&lang=js"
import style0 from "./PointSetting.vue?vue&type=style&index=0&id=f85c764e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85c764e",
  null
  
)

export default component.exports